import { render } from "./ActivityPageDirector.vue?vue&type=template&id=90588e14&scoped=true"
import script from "./ActivityPageDirector.vue?vue&type=script&lang=js"
export * from "./ActivityPageDirector.vue?vue&type=script&lang=js"

import "./ActivityPageDirector.vue?vue&type=style&index=0&id=90588e14&scoped=true&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90588e14"]])

export default __exports__